var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4901 2.22957L5.50015 4.09957C4.35015 4.52957 3.41016 5.88955 3.41016 7.11955V14.5495C3.41016 15.7295 4.19017 17.2795 5.14017 17.9895L9.44016 21.1996C10.8502 22.2596 13.1701 22.2596 14.5801 21.1996L18.8802 17.9895C19.8302 17.2795 20.6101 15.7295 20.6101 14.5495V7.11955C20.6101 5.88955 19.6701 4.52957 18.5201 4.09957L13.5302 2.22957C12.6802 1.91957 11.3201 1.91957 10.4901 2.22957Z",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 10.9204C11.9597 10.9204 11.9097 10.9204 11.8697 10.9204C10.9297 10.8904 10.1797 10.1104 10.1797 9.1604C10.1797 8.1904 10.9697 7.40039 11.9397 7.40039C12.9097 7.40039 13.6997 8.1904 13.6997 9.1604C13.6897 10.1204 12.9397 10.8904 11.9997 10.9204Z",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0091 13.7204C9.04906 14.3604 9.04906 15.4103 10.0091 16.0503C11.0991 16.7803 12.8891 16.7803 13.9791 16.0503C14.9391 15.4103 14.9391 14.3604 13.9791 13.7204C12.8991 12.9904 11.1091 12.9904 10.0091 13.7204Z",
    stroke: "#AC7A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityUser);
export default __webpack_public_path__ + "static/media/security-user.b3a37753af3c30953ec5e53040606fe8.svg";
export { ForwardRef as ReactComponent };